import { Injectable } from "@angular/core";
import { Headers, RequestOptions} from "@angular/http";
import { Observable } from "rxjs/Observable";
import { AdalHttp } from '../../services/adal.http.service';
import { ProjectRequest } from './project-request';
import { ProjectActivityRequest } from './project-activity-request';
import "rxjs/add/operator/map";
import "rxjs/add/operator/do";
import "rxjs/add/operator/catch";


@Injectable()
export class finegrainedService {
    constructor(private http: AdalHttp) {
    }

    getProjects(projectName: string) {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let productUrl: string = `/api/auth/projects/${projectName}/subprojects`;
        return this.http.get(productUrl)
            .catch((error: any) => {
                return Observable.throw(error);
            });

    }

    deleteProject(projectName: string) {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let productUrl: string = `/api/auth/projects/${projectName}`;
        return this.http.delete(productUrl)
            .catch((error: any) => {
                return Observable.throw(error);
            });

    }

    addProject(projectRequest: ProjectRequest): Observable<any> {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let productUrl: string = "/api/auth/projects";
        return this.http.post(productUrl, projectRequest, {
            headers: headers
        })
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    addProjectTag(projectName: string, tagName: string): Observable<any> {
        var headers = new Headers();
        var requestBody = {
            'ProjectName': projectName,
            'TagName': tagName
        };
        headers.append('Content-Type', 'application/json');
        let productUrl: string = "/api/auth/project/tags";
        return this.http.post(productUrl, JSON.stringify(requestBody), {
            headers: headers
        })
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    deleteProjectTag(projectName: string, tagName: string) {

        console.log("execute delete prject tag api")
        var headers = new Headers();
        var body = {
            'ProjectName': projectName,
            'TagName': tagName
        };

        headers.append('Content-Type', 'application/json');
        let productUrl: string = `/api/auth/project/tags`

        let options = new RequestOptions({
            headers: headers,
            body: body
        });

        return this.http.delete(productUrl, options)
            .catch((error: any) => {
                return Observable.throw(error);
            });

    }

    getProjectTags(projectName: string): Observable<any> {
        console.log("execute the fetch project apis")
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let productUrl: string = `/api/auth/projects/${projectName}/tags`;
        return this.http.get(productUrl)
            .catch((error: any) => {
                return Observable.throw(error);
            });

    }

    getProjectActivities(projectName: string) {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let productUrl: string = `/api/auth/projects/${projectName}/activities`;
        return this.http.get(productUrl)
            .catch((error: any) => {
                return Observable.throw(error);
            });

    }

    addProjectActivity(projectActivityRequest: ProjectActivityRequest): Observable<any> {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let productUrl: string = "/api/auth/project/activities";
        return this.http.post(productUrl, projectActivityRequest, {
            headers: headers
        })
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    deleteProjectActivity(projectActivityRequest: ProjectActivityRequest) {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let productUrl: string = `/api/auth/projects/activity`;
        let options = new RequestOptions({
            headers: headers,
            body: projectActivityRequest
        });
        return this.http.delete(productUrl, options)
            .catch((error: any) => {
                return Observable.throw(error);
            });

    }
}


/** WEBPACK FOOTER **
 ** ./app/main/FineGrainedAuthorization/finegrained.service.ts
 **/